// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CustomFieldInputPayload,
    CustomFieldInputPayloadFromJSON,
    CustomFieldInputPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface TestCaseQuickUpdatePayload
 */
export interface TestCaseQuickUpdatePayload {
    /**
     * Test case IDs array
     * @type {Array<number>}
     * @memberof TestCaseQuickUpdatePayload
     */
    testcases: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof TestCaseQuickUpdatePayload
     */
    overwriteTags?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TestCaseQuickUpdatePayload
     */
    suite?: number;
    /**
     * Priority, 0 - Low, 1- Normal, 2 - High
     * @type {number}
     * @memberof TestCaseQuickUpdatePayload
     */
    priority?: TestCaseQuickUpdatePayloadPriorityEnum;
    /**
     * Tag IDs array
     * @type {Array<number>}
     * @memberof TestCaseQuickUpdatePayload
     */
    tags?: Array<number>;
    /**
     * Array of custom fields
     * @type {Array<CustomFieldInputPayload>}
     * @memberof TestCaseQuickUpdatePayload
     */
    customFields?: Array<CustomFieldInputPayload>;
    /**
     * Requirement IDs array
     * @type {Array<number>}
     * @memberof TestCaseQuickUpdatePayload
     */
    requirements?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof TestCaseQuickUpdatePayload
     */
    overwriteRequirements?: boolean;
    /**
     * Default assignee user ID applied to every selected test case. Must be an active project member who can execute test cases. Send 0 to clear the default assignee, omit to leave it unchanged.
     * @type {number}
     * @memberof TestCaseQuickUpdatePayload
     */
    defaultAssignee?: number;
}

export function TestCaseQuickUpdatePayloadFromJSON(json: any): TestCaseQuickUpdatePayload {
    return {
        'testcases': json['testcases'],
        'overwriteTags': !exists(json, 'overwrite_tags') ? undefined : json['overwrite_tags'],
        'suite': !exists(json, 'suite') ? undefined : json['suite'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'customFields': !exists(json, 'custom_fields') ? undefined : (json['custom_fields'] as Array<any>).map(CustomFieldInputPayloadFromJSON),
        'requirements': !exists(json, 'requirements') ? undefined : json['requirements'],
        'overwriteRequirements': !exists(json, 'overwrite_requirements') ? undefined : json['overwrite_requirements'],
        'defaultAssignee': !exists(json, 'default_assignee') ? undefined : json['default_assignee'],
    };
}

export function TestCaseQuickUpdatePayloadToJSON(value?: TestCaseQuickUpdatePayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'testcases': value.testcases,
        'overwrite_tags': value.overwriteTags,
        'suite': value.suite,
        'priority': value.priority,
        'tags': value.tags,
        'custom_fields': value.customFields === undefined ? undefined : (value.customFields as Array<any>).map(CustomFieldInputPayloadToJSON),
        'requirements': value.requirements,
        'overwrite_requirements': value.overwriteRequirements,
        'default_assignee': value.defaultAssignee,
    };
}

/**
* @export
* @enum {string}
*/
export enum TestCaseQuickUpdatePayloadPriorityEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}


